// pages/Documents/Documents.js - UPDATED WITH PER-SECTION VERIFICATION
import React, { useState, useEffect } from "react";
import {
  Container,
  Table,
  Button,
  Modal,
  Spinner,
  Alert,
  Badge,
  Row,
  Col,
  Card,
  Form,
  Image,
  Accordion,
} from "react-bootstrap";
import {
  FaFileAlt,
  FaCheckCircle,
  FaTimesCircle,
  FaClock,
  FaEye,
  FaStore,
  FaEnvelope,
  FaPhone,
  FaCalendarAlt,
  FaCheck,
  FaTimes,
  FaUsers,
  FaLink,
  FaCopy,
  FaFileUpload,
  FaExclamationTriangle,
  FaSync,
  FaIdCard,
  FaFileInvoice,
  FaBuilding,
  FaUniversity,
  FaDownload,
  FaEyeSlash,
  FaInfoCircle,
  FaHistory,
  FaArrowRight,
  FaArrowLeft,
   FaImage,
} from "react-icons/fa";
import axios from "axios";
import Header from "../../component/header/header";
import Sidebar from "../../component/sidebar/sidebar";
import "./Documents.css";

//const SELLER_API_URL = "http://localhost:5177/api/seller";
//const API_BASE = "http://localhost:5177";
const SELLER_API_URL = "https://api-admin.native91.com/api/seller";
 const API_BASE = "https://api-admin.native91.com";
// Helper function to get full image URL
const getImageUrl = (imagePath) => {
  if (!imagePath) return null;
  if (imagePath.startsWith('http')) return imagePath;
  if (imagePath.startsWith('/uploads')) return `${API_BASE}${imagePath}`;
  return `${API_BASE}${imagePath}`;
};

// Section labels for display
const SECTION_LABELS = {
  logo: 'Company Logo',
  brand: 'Brand Description',
  aadhaar: 'Aadhaar Details',
  pan: 'PAN Details',
  gst: 'GST Details',
  bank: 'Bank Details',
  contact: 'Contact Information',
  business: 'Business Information'
};

// Section icons
const SECTION_ICONS = {
  logo: <FaImage className="me-2" />,
  brand: <FaInfoCircle className="me-2" />,
  aadhaar: <FaIdCard className="me-2" />,
  pan: <FaFileInvoice className="me-2" />,
  gst: <FaBuilding className="me-2" />,
  bank: <FaUniversity className="me-2" />,
  contact: <FaPhone className="me-2" />,
  business: <FaStore className="me-2" />
};

const Documents = () => {
  const [documents, setDocuments] = useState([]);
  const [filteredDocs, setFilteredDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [syncing, setSyncing] = useState(false);

  const [showDetail, setShowDetail] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  
  // Per-section verification modals
  const [showSectionVerifyModal, setShowSectionVerifyModal] = useState(false);
  const [showSectionRejectModal, setShowSectionRejectModal] = useState(false);
  const [selectedSection, setSelectedSection] = useState(null);
  const [rejectionReason, setRejectionReason] = useState("");
  
  // Overall verification modal
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);

  const token = localStorage.getItem("token");

  const fetchDocuments = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${SELLER_API_URL}/admin/documents`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.success) {
        setDocuments(res.data.documents || []);
        setFilteredDocs(res.data.documents || []);
      } else {
        setError("Failed to fetch documents");
      }
    } catch (err) {
      console.error("Fetch documents error:", err);
      if (err.response?.status === 401) {
        setError("Session expired. Please login again.");
      } else {
        setError(err.response?.data?.message || "Failed to fetch documents");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, []);

  useEffect(() => {
    let filtered = documents;

    if (statusFilter !== "all") {
      filtered = filtered.filter((doc) => doc.status === statusFilter);
    }

    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter(
        (doc) =>
          doc.email?.toLowerCase().includes(term) ||
          doc.company?.toLowerCase().includes(term) ||
          doc.trackingId?.toLowerCase().includes(term)
      );
    }

    setFilteredDocs(filtered);
  }, [documents, statusFilter, searchTerm]);

  // ================= VERIFY SINGLE SECTION =================
  const handleVerifySection = async () => {
    if (!selectedDoc || !selectedSection) return;

    setActionLoading(true);
    setError("");
    setSuccess("");

    try {
      const res = await axios.patch(
        `${SELLER_API_URL}/admin/documents/${selectedDoc._id}/verify-section`,
        { section: selectedSection },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.success) {
        setSuccess(`✅ ${SECTION_LABELS[selectedSection]} verified successfully!`);
        
        if (res.data.allVerified) {
          setSuccess(`✅ All documents verified! Vendor account created and credentials sent to ${selectedDoc.email}`);
        }
        
        setShowSectionVerifyModal(false);
        setSelectedSection(null);
        await fetchDocuments();
      }
    } catch (err) {
      console.error("❌ Verify section error:", err);
      setError(err.response?.data?.message || "Failed to verify section");
    } finally {
      setActionLoading(false);
    }
  };

  // ================= REJECT SINGLE SECTION =================
  const handleRejectSection = async () => {
    if (!selectedDoc || !selectedSection) return;

    if (!rejectionReason.trim()) {
      setError("Please provide a reason for rejection");
      return;
    }

    setActionLoading(true);
    setError("");
    setSuccess("");

    try {
      const res = await axios.patch(
        `${SELLER_API_URL}/admin/documents/${selectedDoc._id}/reject-section`,
        { 
          section: selectedSection,
          reason: rejectionReason 
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.success) {
        setSuccess(`❌ ${SECTION_LABELS[selectedSection]} rejected. Email sent to vendor.`);
        setShowSectionRejectModal(false);
        setRejectionReason("");
        setSelectedSection(null);
        await fetchDocuments();
      }
    } catch (err) {
      console.error("❌ Reject section error:", err);
      setError(err.response?.data?.message || "Failed to reject section");
    } finally {
      setActionLoading(false);
    }
  };

  // ================= VERIFY ALL DOCUMENTS =================
  const handleVerifyAll = async () => {
    if (!selectedDoc) return;

    setActionLoading(true);
    setError("");
    setSuccess("");

    try {
      const res = await axios.patch(
        `${SELLER_API_URL}/admin/documents/verify/${selectedDoc._id}`,
        { status: "verified" },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.success) {
        setSuccess(
          `✅ Documents for ${selectedDoc.email} verified successfully! Vendor login credentials have been sent.`
        );
        setShowVerifyModal(false);
        setSelectedDoc(null);
        await fetchDocuments();
      } else {
        setError(res.data.message || "Failed to verify documents");
      }
    } catch (err) {
      console.error("❌ Verify error:", err);
      setError(err.response?.data?.message || "Failed to verify documents");
    } finally {
      setActionLoading(false);
    }
  };

  // ================= REJECT ALL DOCUMENTS =================
  const handleRejectAll = async () => {
    if (!selectedDoc) return;

    if (!rejectionReason.trim()) {
      setError("Please provide a reason for rejection");
      return;
    }

    setActionLoading(true);
    setError("");
    setSuccess("");

    try {
      const res = await axios.patch(
        `${SELLER_API_URL}/admin/documents/verify/${selectedDoc._id}`,
        { status: "rejected", rejectionReason: rejectionReason },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.success) {
        setSuccess(`✅ Documents for ${selectedDoc.email} rejected! Rejection email sent.`);
        setShowRejectModal(false);
        setRejectionReason("");
        await fetchDocuments();
      }
    } catch (err) {
      console.error("❌ Reject error:", err);
      setError(err.response?.data?.message || "Failed to reject documents");
    } finally {
      setActionLoading(false);
    }
  };

  // ================= GET STATUS BADGE =================
  const getStatusBadge = (status) => {
    switch (status) {
      case "verified":
        return (
          <Badge bg="success" className="px-3 py-2">
            <FaCheckCircle className="me-1" /> Verified
          </Badge>
        );
      case "submitted":
        return (
          <Badge bg="warning" className="px-3 py-2">
            <FaClock className="me-1" /> Pending
          </Badge>
        );
      case "pending_review":
        return (
          <Badge bg="info" className="px-3 py-2">
            <FaClock className="me-1" /> In Review
          </Badge>
        );
      case "partially_rejected":
        return (
          <Badge bg="danger" className="px-3 py-2">
            <FaTimesCircle className="me-1" /> Partially Rejected
          </Badge>
        );
      case "rejected":
        return (
          <Badge bg="danger" className="px-3 py-2">
            <FaTimesCircle className="me-1" /> Rejected
          </Badge>
        );
      default:
        return (
          <Badge bg="secondary" className="px-3 py-2">
            <FaClock className="me-1" /> Draft
          </Badge>
        );
    }
  };

  // ================= GET SECTION STATUS BADGE =================
  const getSectionStatusBadge = (status) => {
    switch (status) {
      case "verified":
        return <Badge bg="success" className="px-2 py-1"><FaCheckCircle className="me-1" size={12} /> Verified</Badge>;
      case "rejected":
        return <Badge bg="danger" className="px-2 py-1"><FaTimesCircle className="me-1" size={12} /> Rejected</Badge>;
      case "resubmitted":
        return <Badge bg="warning" className="px-2 py-1"><FaSync className="me-1" size={12} /> Resubmitted</Badge>;
      case "pending":
        return <Badge bg="secondary" className="px-2 py-1"><FaClock className="me-1" size={12} /> Pending</Badge>;
      default:
        return <Badge bg="secondary" className="px-2 py-1">Pending</Badge>;
    }
  };

  // ================= GET SECTION STATUS COLOR =================
  const getSectionStatusColor = (status) => {
    switch (status) {
      case "verified": return "success";
      case "rejected": return "danger";
      case "resubmitted": return "warning";
      default: return "secondary";
    }
  };

  // ================= RENDER SECTION STATUS CARD =================
  const renderSectionStatusCard = (section, data) => {
    if (!data) return null;
    
    const status = data.status || 'pending';
    const rejectionReason = data.rejectionReason || '';
    const resubmittedAt = data.resubmittedAt || null;
    
    return (
      <Card className={`mb-2 border-${getSectionStatusColor(status)}`}>
        <Card.Body className="py-2">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <span className="fw-bold">{SECTION_ICONS[section] || <FaFileAlt className="me-2" />}</span>
              <span className="fw-bold">{SECTION_LABELS[section] || section}</span>
            </div>
            <div>
              {getSectionStatusBadge(status)}
            </div>
          </div>
          
          {rejectionReason && (
            <div className="text-danger small mt-1">
              <strong>Reason:</strong> {rejectionReason}
            </div>
          )}
          
          {resubmittedAt && (
            <div className="text-warning small mt-1">
              <FaHistory className="me-1" />
              Resubmitted: {new Date(resubmittedAt).toLocaleString()}
            </div>
          )}

          {/* Action buttons for each section */}
          {(selectedDoc?.status === 'submitted' || selectedDoc?.status === 'pending_review' || selectedDoc?.status === 'partially_rejected') && (
            <div className="mt-2">
              {status !== 'verified' && status !== 'rejected' && (
                <>
                  <Button 
                    size="sm" 
                    variant="success" 
                    className="me-2"
                    onClick={() => {
                      setSelectedSection(section);
                      setShowSectionVerifyModal(true);
                    }}
                    disabled={actionLoading}
                  >
                    <FaCheck className="me-1" size={12} /> Verify
                  </Button>
                  <Button 
                    size="sm" 
                    variant="danger"
                    onClick={() => {
                      setSelectedSection(section);
                      setRejectionReason('');
                      setShowSectionRejectModal(true);
                    }}
                    disabled={actionLoading}
                  >
                    <FaTimes className="me-1" size={12} /> Reject
                  </Button>
                </>
              )}
              {status === 'rejected' && (
                <Button 
                  size="sm" 
                  variant="warning"
                  onClick={() => {
                    setSelectedSection(section);
                    setShowSectionVerifyModal(true);
                  }}
                  disabled={actionLoading}
                >
                  <FaCheck className="me-1" size={12} /> Re-verify
                </Button>
              )}
              {status === 'resubmitted' && (
                <>
                  <Button 
                    size="sm" 
                    variant="success" 
                    className="me-2"
                    onClick={() => {
                      setSelectedSection(section);
                      setShowSectionVerifyModal(true);
                    }}
                    disabled={actionLoading}
                  >
                    <FaCheck className="me-1" size={12} /> Verify Resubmitted
                  </Button>
                  <Button 
                    size="sm" 
                    variant="danger"
                    onClick={() => {
                      setSelectedSection(section);
                      setRejectionReason('');
                      setShowSectionRejectModal(true);
                    }}
                    disabled={actionLoading}
                  >
                    <FaTimes className="me-1" size={12} /> Reject Again
                  </Button>
                </>
              )}
            </div>
          )}
        </Card.Body>
      </Card>
    );
  };

  // ================= RENDER SECTION DETAILS =================
  const renderSectionDetails = (section, data) => {
    if (!data) return null;
    
    // Special handling for different sections
    if (section === 'logo' && data.image) {
      return (
        <div className="mt-2">
          <Image 
            src={getImageUrl(data.image)} 
            alt="Logo" 
            style={{ maxWidth: '100px', maxHeight: '100px', objectFit: 'contain' }}
            thumbnail
          />
        </div>
      );
    }
    
    if (section === 'brand' && data.description) {
      return (
        <div className="mt-2 small text-muted">
          <p className="mb-0">{data.description}</p>
        </div>
      );
    }
    
    if (section === 'aadhaar') {
      return (
        <div className="mt-2 small">
          <div>Number: <strong>{data.number || 'N/A'}</strong></div>
          {data.frontImage && (
            <div><a href={getImageUrl(data.frontImage)} target="_blank" rel="noopener noreferrer">View Front</a></div>
          )}
          {data.backImage && (
            <div><a href={getImageUrl(data.backImage)} target="_blank" rel="noopener noreferrer">View Back</a></div>
          )}
        </div>
      );
    }
    
    if (section === 'pan') {
      return (
        <div className="mt-2 small">
          <div>Number: <strong>{data.number || 'N/A'}</strong></div>
          {data.image && (
            <div><a href={getImageUrl(data.image)} target="_blank" rel="noopener noreferrer">View Document</a></div>
          )}
        </div>
      );
    }
    
    if (section === 'gst') {
      return (
        <div className="mt-2 small">
          <div>Number: <strong>{data.number || 'N/A'}</strong></div>
          {data.certificate && (
            <div><a href={getImageUrl(data.certificate)} target="_blank" rel="noopener noreferrer">View Certificate</a></div>
          )}
        </div>
      );
    }
    
    if (section === 'bank') {
      return (
        <div className="mt-2 small">
          <div>Holder: <strong>{data.accountHolderName || 'N/A'}</strong></div>
          <div>Account: <strong>****{data.accountNumber?.slice(-4) || 'N/A'}</strong></div>
          <div>IFSC: <strong>{data.ifscCode || 'N/A'}</strong></div>
          <div>Bank: <strong>{data.bankName || 'N/A'}</strong></div>
          {data.upiId && <div>UPI: <strong>{data.upiId}</strong></div>}
        </div>
      );
    }
    
    if (section === 'contact') {
      return (
        <div className="mt-2 small">
          <div>Phone: <strong>{data.phone || 'N/A'}</strong></div>
          {data.alternatePhone && <div>Alternate: <strong>{data.alternatePhone}</strong></div>}
          <div>Address: <strong>{data.address || 'N/A'}</strong></div>
          {data.city && <div>City: <strong>{data.city}</strong></div>}
          {data.state && <div>State: <strong>{data.state}</strong></div>}
          {data.pincode && <div>Pincode: <strong>{data.pincode}</strong></div>}
        </div>
      );
    }
    
    if (section === 'business') {
      return (
        <div className="mt-2 small">
          <div>Type: <strong>{data.registrationType || 'N/A'}</strong></div>
          <div>Number: <strong>{data.registrationNumber || 'N/A'}</strong></div>
          {data.certificate && (
            <div><a href={getImageUrl(data.certificate)} target="_blank" rel="noopener noreferrer">View Certificate</a></div>
          )}
        </div>
      );
    }
    
    return null;
  };

  const getStats = () => {
    const total = documents.length;
    const draft = documents.filter((d) => d.status === "draft").length;
    const submitted = documents.filter((d) => d.status === "submitted" || d.status === "pending_review").length;
    const verified = documents.filter((d) => d.status === "verified").length;
    const rejected = documents.filter((d) => d.status === "rejected" || d.status === "partially_rejected").length;
    return { total, draft, submitted, verified, rejected };
  };

  const stats = getStats();

  // ================= CHECK IF ANY SECTION CAN BE VERIFIED =================
  const hasVerifiableSections = (doc) => {
    if (!doc) return false;
    const sections = ['brand', 'aadhaar', 'pan', 'bank', 'contact', 'business'];
    for (const section of sections) {
      if (doc[section] && doc[section].status !== 'verified' && doc[section].status !== 'rejected') {
        return true;
      }
    }
    return false;
  };

  if (loading) {
    return (
      <>
        <Header />
        <Sidebar />
        <main className="admin-content mt-5">
          <Container>
            <div className="text-center py-5">
              <Spinner animation="border" variant="primary" />
              <p className="mt-3">Loading documents...</p>
            </div>
          </Container>
        </main>
      </>
    );
  }

  return (
    <>
      <Header />
      <Sidebar />
      <main className="admin-content mt-5">
        <Container fluid>
          {error && (
            <Alert variant="danger" onClose={() => setError("")} dismissible>
              <FaExclamationTriangle className="me-2" />
              {error}
            </Alert>
          )}
          {success && (
            <Alert variant="success" onClose={() => setSuccess("")} dismissible>
              {success}
            </Alert>
          )}

          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4>
              <FaFileAlt className="me-2" />
              Seller Documents
              <Badge bg="secondary" className="ms-2">
                {filteredDocs.length}
              </Badge>
            </h4>
            <Button
              variant="outline-info"
              size="sm"
              onClick={fetchDocuments}
              disabled={loading}
            >
              <FaSync className={loading ? "fa-spin" : ""} /> 
              {loading ? "Loading..." : "Refresh"}
            </Button>
          </div>

          {/* Stats Cards */}
          <Row className="mb-4">
            <Col md={3}>
              <Card className="text-center shadow-sm">
                <Card.Body>
                  <h6 className="text-muted">Total</h6>
                  <h3>{stats.total}</h3>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3}>
              <Card className="text-center shadow-sm border-secondary">
                <Card.Body>
                  <h6 className="text-muted">Draft</h6>
                  <h3 className="text-secondary">{stats.draft}</h3>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3}>
              <Card className="text-center shadow-sm border-warning">
                <Card.Body>
                  <h6 className="text-muted">Pending</h6>
                  <h3 className="text-warning">{stats.submitted}</h3>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3}>
              <Card className="text-center shadow-sm border-success">
                <Card.Body>
                  <h6 className="text-muted">Verified</h6>
                  <h3 className="text-success">{stats.verified}</h3>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Filters */}
          <Row className="mb-4">
            <Col md={8}>
              <Form.Control
                type="text"
                placeholder="Search by email, company, or tracking ID..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-100"
              />
            </Col>
            <Col md={4}>
              <Form.Select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="all">All Status</option>
                <option value="draft">Draft</option>
                <option value="submitted">Submitted</option>
                <option value="pending_review">Pending Review</option>
                <option value="partially_rejected">Partially Rejected</option>
                <option value="verified">Verified</option>
                <option value="rejected">Rejected</option>
              </Form.Select>
            </Col>
          </Row>

          {/* Table */}
          <div className="table-responsive">
            <Table bordered hover className="documents-table">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Tracking ID</th>
                  <th>Email</th>
                  <th>Company</th>
                  <th>Documents</th>
                  <th>Status</th>
                  <th>Submitted</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredDocs.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="text-center py-5 text-muted">
                      <FaFileAlt size={40} className="mb-3" />
                      <p>No documents found</p>
                    </td>
                  </tr>
                ) : (
                  filteredDocs.map((doc, index) => {
                    // Check section statuses
                    const sections = ['brand', 'aadhaar', 'pan', 'bank', 'contact', 'business'];
                    const hasRejected = sections.some(s => doc[s]?.status === 'rejected');
                    const hasResubmitted = sections.some(s => doc[s]?.status === 'resubmitted');
                    const allVerified = sections.every(s => doc[s]?.status === 'verified');
                    
                    return (
                      <tr key={doc._id}>
                        <td>{index + 1}</td>
                        <td>
                          <code className="fw-bold">{doc.trackingId}</code>
                        </td>
                        <td>{doc.email}</td>
                        <td>{doc.company}</td>
                        <td>
                          <div className="d-flex flex-wrap gap-1">
                            {doc.aadhaar?.number && (
                              <Badge bg={doc.aadhaar.status === 'verified' ? 'success' : doc.aadhaar.status === 'rejected' ? 'danger' : 'secondary'}>
                                Aadhaar {doc.aadhaar.status === 'verified' && '✓'}
                              </Badge>
                            )}
                            {doc.pan?.number && (
                              <Badge bg={doc.pan.status === 'verified' ? 'success' : doc.pan.status === 'rejected' ? 'danger' : 'secondary'}>
                                PAN {doc.pan.status === 'verified' && '✓'}
                              </Badge>
                            )}
                            {doc.gst?.number && (
                              <Badge bg={doc.gst.status === 'verified' ? 'success' : doc.gst.status === 'rejected' ? 'danger' : 'secondary'}>
                                GST {doc.gst.status === 'verified' && '✓'}
                              </Badge>
                            )}
                            {doc.bank?.accountNumber && (
                              <Badge bg={doc.bank.status === 'verified' ? 'success' : doc.bank.status === 'rejected' ? 'danger' : 'secondary'}>
                                Bank {doc.bank.status === 'verified' && '✓'}
                              </Badge>
                            )}
                            {doc.business?.registrationNumber && (
                              <Badge bg={doc.business.status === 'verified' ? 'success' : doc.business.status === 'rejected' ? 'danger' : 'secondary'}>
                                Business {doc.business.status === 'verified' && '✓'}
                              </Badge>
                            )}
                            {doc.brand?.description && (
                              <Badge bg={doc.brand.status === 'verified' ? 'success' : doc.brand.status === 'rejected' ? 'danger' : 'secondary'}>
                                Brand {doc.brand.status === 'verified' && '✓'}
                              </Badge>
                            )}
                          </div>
                          {hasRejected && (
                            <div className="mt-1">
                              <Badge bg="danger" className="me-1">
                                <FaTimesCircle className="me-1" /> Rejected
                              </Badge>
                            </div>
                          )}
                          {hasResubmitted && (
                            <div className="mt-1">
                              <Badge bg="warning">
                                <FaSync className="me-1" /> Resubmitted
                              </Badge>
                            </div>
                          )}
                        </td>
                        <td>
                          {allVerified && doc.status !== 'verified' ? getStatusBadge('verified') : getStatusBadge(doc.status)}
                        </td>
                        <td>
                          {doc.submissionDate
                            ? new Date(doc.submissionDate).toLocaleDateString()
                            : "N/A"}
                        </td>
                        <td>
                          <Button
                            size="sm"
                            variant="outline-primary"
                            className="me-1"
                            onClick={() => {
                              setSelectedDoc(doc);
                              setShowDetail(true);
                            }}
                            title="View Details"
                          >
                            <FaEye />
                          </Button>
                          
                          {/* Overall actions for submitted/pending documents */}
                          {(doc.status === "submitted" || doc.status === "pending_review" || doc.status === "partially_rejected") && (
                            <>
                              {hasVerifiableSections(doc) && (
                                <Button
                                  size="sm"
                                  variant="outline-success"
                                  className="me-1"
                                  onClick={() => {
                                    setSelectedDoc(doc);
                                    setShowVerifyModal(true);
                                  }}
                                  title="Verify All"
                                >
                                  <FaCheck />
                                </Button>
                              )}
                              <Button
                                size="sm"
                                variant="outline-danger"
                                onClick={() => {
                                  setSelectedDoc(doc);
                                  setRejectionReason('');
                                  setShowRejectModal(true);
                                }}
                                title="Reject All"
                              >
                                <FaTimes />
                              </Button>
                            </>
                          )}
                          {doc.status === "verified" && (
                            <Badge bg="success">✓ Verified</Badge>
                          )}
                          {doc.status === "rejected" && (
                            <Badge bg="danger">✗ Rejected</Badge>
                          )}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>
        </Container>
      </main>

      {/* ================= DETAIL MODAL WITH SECTION STATUS ================= */}
      <Modal show={showDetail} onHide={() => setShowDetail(false)} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title>
            <FaFileAlt className="me-2" />
            Document Details
            {selectedDoc && (
              <Badge bg="secondary" className="ms-2">
                {selectedDoc.trackingId}
              </Badge>
            )}
          </Modal.Title>
        </Modal.Header>
        {selectedDoc && (
          <Modal.Body>
            {/* Overview */}
            <Row className="mb-3">
              <Col md={6}>
                <div className="detail-item">
                  <label>Email</label>
                  <p><FaEnvelope className="me-1 text-muted" /> {selectedDoc.email}</p>
                </div>
                <div className="detail-item">
                  <label>Company</label>
                  <p><FaStore className="me-1 text-primary" /> {selectedDoc.company}</p>
                </div>
              </Col>
              <Col md={6}>
                <div className="detail-item">
                  <label>Overall Status</label>
                  <p>{getStatusBadge(selectedDoc.status)}</p>
                </div>
                <div className="detail-item">
                  <label>Submitted On</label>
                  <p>
                    <FaCalendarAlt className="me-1 text-muted" />
                    {selectedDoc.submissionDate
                      ? new Date(selectedDoc.submissionDate).toLocaleString()
                      : "Not submitted yet"}
                  </p>
                </div>
              </Col>
            </Row>

            <hr />
            <h6 className="mb-3">Section Status & Verification</h6>
            
            {/* Section Status Cards */}
            <Row>
              {/* Brand Description */}
              <Col md={6}>
                {renderSectionStatusCard('brand', selectedDoc.brand)}
                {renderSectionDetails('brand', selectedDoc.brand)}
              </Col>
              
              {/* Logo */}
              <Col md={6}>
                {renderSectionStatusCard('logo', selectedDoc.logo)}
                {renderSectionDetails('logo', selectedDoc.logo)}
              </Col>
              
              {/* Aadhaar */}
              <Col md={6}>
                {renderSectionStatusCard('aadhaar', selectedDoc.aadhaar)}
                {renderSectionDetails('aadhaar', selectedDoc.aadhaar)}
              </Col>
              
              {/* PAN */}
              <Col md={6}>
                {renderSectionStatusCard('pan', selectedDoc.pan)}
                {renderSectionDetails('pan', selectedDoc.pan)}
              </Col>
              
              {/* GST */}
              <Col md={6}>
                {renderSectionStatusCard('gst', selectedDoc.gst)}
                {renderSectionDetails('gst', selectedDoc.gst)}
              </Col>
              
              {/* Bank */}
              <Col md={6}>
                {renderSectionStatusCard('bank', selectedDoc.bank)}
                {renderSectionDetails('bank', selectedDoc.bank)}
              </Col>
              
              {/* Contact */}
              <Col md={6}>
                {renderSectionStatusCard('contact', selectedDoc.contact)}
                {renderSectionDetails('contact', selectedDoc.contact)}
              </Col>
              
              {/* Business */}
              <Col md={6}>
                {renderSectionStatusCard('business', selectedDoc.business)}
                {renderSectionDetails('business', selectedDoc.business)}
              </Col>
            </Row>

            {/* Legend */}
            <Alert variant="info" className="mt-3">
              <small>
                <strong>Legend:</strong>
                <Badge bg="success" className="ms-2 me-1">Verified</Badge>
                <Badge bg="danger" className="ms-2 me-1">Rejected</Badge>
                <Badge bg="warning" className="ms-2 me-1">Resubmitted</Badge>
                <Badge bg="secondary" className="ms-2 me-1">Pending</Badge>
              </small>
            </Alert>
          </Modal.Body>
        )}
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDetail(false)}>Close</Button>
        </Modal.Footer>
      </Modal>

      {/* ================= SECTION VERIFY MODAL ================= */}
      <Modal show={showSectionVerifyModal} onHide={() => setShowSectionVerifyModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <FaCheckCircle className="me-2 text-success" />
            Verify {selectedSection ? SECTION_LABELS[selectedSection] : ''}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedDoc && selectedSection && (
            <>
              <p><strong>Email:</strong> {selectedDoc.email}</p>
              <p><strong>Company:</strong> {selectedDoc.company}</p>
              <p><strong>Section:</strong> {SECTION_LABELS[selectedSection]}</p>
              
              {selectedDoc[selectedSection]?.status === 'rejected' && (
                <Alert variant="warning">
                  <strong>⚠️ This section was previously rejected.</strong>
                  {selectedDoc[selectedSection]?.rejectionReason && (
                    <div className="mt-1">
                      <strong>Previous reason:</strong> {selectedDoc[selectedSection].rejectionReason}
                    </div>
                  )}
                  <div className="mt-1">
                    Review the resubmitted document before verifying.
                  </div>
                </Alert>
              )}
              
              {selectedDoc[selectedSection]?.status === 'resubmitted' && (
                <Alert variant="info">
                  <FaSync className="me-2" />
                  <strong>This section was resubmitted</strong> on {new Date(selectedDoc[selectedSection].resubmittedAt).toLocaleString()}
                </Alert>
              )}
              
              <Alert variant="success" className="mt-3">
                <strong>This will:</strong>
                <ul className="mb-0 mt-1">
                  <li>✅ Mark {SECTION_LABELS[selectedSection]} as verified</li>
                  <li>✅ Clear any rejection status</li>
                  {selectedDoc[selectedSection]?.status === 'resubmitted' && (
                    <li>✅ Acknowledge the resubmission</li>
                  )}
                </ul>
              </Alert>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowSectionVerifyModal(false)}>Cancel</Button>
          <Button variant="success" onClick={handleVerifySection} disabled={actionLoading}>
            {actionLoading ? <Spinner size="sm" className="me-2" /> : <FaCheck className="me-2" />}
            Verify {selectedSection ? SECTION_LABELS[selectedSection] : ''}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ================= SECTION REJECT MODAL ================= */}
      <Modal show={showSectionRejectModal} onHide={() => setShowSectionRejectModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <FaTimesCircle className="me-2 text-danger" />
            Reject {selectedSection ? SECTION_LABELS[selectedSection] : ''}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedDoc && selectedSection && (
            <>
              <p><strong>Email:</strong> {selectedDoc.email}</p>
              <p><strong>Company:</strong> {selectedDoc.company}</p>
              <p><strong>Section:</strong> {SECTION_LABELS[selectedSection]}</p>
              
              {selectedDoc[selectedSection]?.status === 'resubmitted' && (
                <Alert variant="info">
                  <FaSync className="me-2" />
                  <strong>This section was resubmitted</strong> on {new Date(selectedDoc[selectedSection].resubmittedAt).toLocaleString()}
                </Alert>
              )}
              
              <Form.Group className="mt-3">
                <Form.Label>Rejection Reason <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Please provide a reason for rejecting this specific document..."
                  value={rejectionReason}
                  onChange={(e) => setRejectionReason(e.target.value)}
                  required
                />
                <Form.Text className="text-muted">
                  This reason will be sent to the vendor via email.
                </Form.Text>
              </Form.Group>
              
              <Alert variant="danger" className="mt-3">
                <strong>This will:</strong>
                <ul className="mb-0 mt-1">
                  <li>❌ Mark {SECTION_LABELS[selectedSection]} as rejected</li>
                  <li>📧 Send rejection email to <strong>{selectedDoc.email}</strong></li>
                  <li>📝 Include the rejection reason</li>
                  <li>🔄 Vendor can resubmit only this section</li>
                </ul>
              </Alert>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowSectionRejectModal(false)}>Cancel</Button>
          <Button variant="danger" onClick={handleRejectSection} disabled={actionLoading}>
            {actionLoading ? <Spinner size="sm" className="me-2" /> : <FaTimes className="me-2" />}
            Reject & Send Email
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ================= VERIFY ALL MODAL ================= */}
      <Modal show={showVerifyModal} onHide={() => setShowVerifyModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <FaCheckCircle className="me-2 text-success" />
            Verify All Documents
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedDoc && (
            <>
              <p><strong>Email:</strong> {selectedDoc.email}</p>
              <p><strong>Company:</strong> {selectedDoc.company}</p>
              <p><strong>Tracking ID:</strong> <code>{selectedDoc.trackingId}</code></p>
              
              {/* Show which sections will be verified */}
              <div className="mt-3">
                <strong>Sections to verify:</strong>
                <ul className="mt-1">
                  {['brand', 'aadhaar', 'pan', 'bank', 'contact', 'business'].map(section => {
                    if (selectedDoc[section]?.status !== 'verified') {
                      return (
                        <li key={section}>
                          {SECTION_LABELS[section]}
                          {selectedDoc[section]?.status === 'rejected' && (
                            <Badge bg="danger" className="ms-2">Previously Rejected</Badge>
                          )}
                          {selectedDoc[section]?.status === 'resubmitted' && (
                            <Badge bg="warning" className="ms-2">Resubmitted</Badge>
                          )}
                        </li>
                      );
                    }
                    return null;
                  })}
                </ul>
              </div>
              
              <Alert variant="success" className="mt-3">
                <strong>This will:</strong>
                <ul className="mb-0 mt-1">
                  <li>✅ Verify all pending/approved sections</li>
                  <li>✅ Mark seller as verified</li>
                  <li>✅ Create/activate vendor account</li>
                  <li>📧 Send login credentials to <strong>{selectedDoc.email}</strong></li>
                </ul>
              </Alert>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowVerifyModal(false)}>Cancel</Button>
          <Button variant="success" onClick={handleVerifyAll} disabled={actionLoading}>
            {actionLoading ? <Spinner size="sm" className="me-2" /> : <FaCheck className="me-2" />}
            Verify All & Send Credentials
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ================= REJECT ALL MODAL ================= */}
      <Modal show={showRejectModal} onHide={() => setShowRejectModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <FaTimesCircle className="me-2 text-danger" />
            Reject All Documents
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedDoc && (
            <>
              <p><strong>Email:</strong> {selectedDoc.email}</p>
              <p><strong>Company:</strong> {selectedDoc.company}</p>
              <Form.Group className="mt-3">
                <Form.Label>Rejection Reason <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Please provide a reason for rejecting all documents..."
                  value={rejectionReason}
                  onChange={(e) => setRejectionReason(e.target.value)}
                  required
                />
              </Form.Group>
              <Alert variant="danger" className="mt-3">
                <strong>This will:</strong>
                <ul className="mb-0 mt-1">
                  <li>❌ Reject all documents</li>
                  <li>📧 Send rejection email to <strong>{selectedDoc.email}</strong></li>
                </ul>
              </Alert>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowRejectModal(false)}>Cancel</Button>
          <Button variant="danger" onClick={handleRejectAll} disabled={actionLoading}>
            {actionLoading ? <Spinner size="sm" className="me-2" /> : <FaTimes className="me-2" />}
            Reject All & Send Email
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Documents;
